<script>
    import { onMount } from "svelte";
    import wrappedFetch from "../../wrappedFetch.js";
    import Spinner from "../components/spinner.svelte";
    import Card from "../components/card.svelte";
    import Modal from "../components/modal.svelte";
    import ModalConfirm from "../components/modalconfirm.svelte";
    import DataTable from "../../components/data-table.svelte";
    import Button from "../components/button.svelte";
    import moment from "moment";
    import NoDataFound from "../components/nodatainfo.svelte";
    import  { resolveExportUrl } from "../../router.js";

    export let providerId = 0;

    let titleProvider = providerId == 1 ? "Google" : providerId == 3 ? "Microsoft" : "";
    let classes = [];
    let allClasses = [];
    let isPageLoading;
    let showDetails = false;
    let studentsInClass = [];
    let isFetchingStudents = false;
    let showArchived = false;
    // let targets = providerId == 1 ? [4, 5] : [4];
    let targets = providerId == 1 ? [3, 4] : [3];
    let columnDefs = [{ type: 'date-euro', targets: targets }];
    let showConfirmationModal = false;
    let selectedCourseId = '';
    let teachersInClass = [];

    onMount(async () => {
        isPageLoading = true;
        // let resp = await wrappedFetch(
        //     `/api/cloud/GetClasses?providerId=${providerId}`,
        //     { method: "post" }
        // );

        // allClasses = await resp.json();
        
        // classes = allClasses.result;
        //await GetTotalNumberOfClasses();
       classes =  await GetClasses();
       
        // console.log(classes);
        isPageLoading = false;
    });
    // const GetTotalNumberOfClasses = async() =>{
    //     let resp = await wrappedFetch(
    //         `/api/cloud/GetTotalNumberOfClasses?providerId=${providerId}`,
    //         { method: "post" }
    //     );

    //     let result = await resp.json();
    //     totalNumberOfClasses = result;
    //     console.log('totalClasses = ',result);
    // }
    const GetClasses=async()=>{
       // isPageLoading = true;
        let resp = await wrappedFetch(
            `/api/cloud/GetClasses?providerId=${providerId}`,
            { method: "post" }
        );

        let result = await resp.json();    
        allClasses = result.result;         
        return allClasses;       
    }

    // const loadMoreClasses = async() =>{
    //      let newClasses = await GetClasses();
    //     //  moreClasses =moreClasses.concat(newClasses);
    //       classes = classes.concat(newClasses);
    //    //  console.log('moreClasses',moreClasses);
    //   //  classes.push(...moreClasses) ;
    //     console.log('load more classes = ',classes)

    // }

    const onClickArchive = async (classId) => {
        showConfirmationModal = true;
        selectedCourseId = classId;
    };

    const archiveClass = async (classId) => {

        classes.find(x => x.id == classId).isSyncedByNimbus = false;
        if (providerId == 1) 
            classes.find(x => x.id == classId).courseState = 'ARCHIVED';
        
        showConfirmationModal = false;
        await wrappedFetch(
            `/api/cloud/ArchiveClass?providerId=${providerId}&courseId=${classId}`, //&setTrue=${isArchived}
            { method: "post" }
        );
    };

    const getStudentsInClass = async (classId, students) => {

        showDetails = true;
        isFetchingStudents = true;

        if (students == null || students.length == 0) {
            var resp = await wrappedFetch(
                `/api/cloud/GetStudentsInClass?providerId=${providerId}&courseId=${classId}`,
                { method: "post" }
            );
            let res = await resp.json();
            console.log('res',res)
            studentsInClass = res.names;
            teachersInClass = res.teachers;             
        } else {
            studentsInClass = students;
        }
        isFetchingStudents = false;
    };

    
    const handleChangeFilter = () => {
        // console.log(showArchived);
        showArchived = !showArchived;
        if (showArchived == true)
            classes = allClasses.filter((u) => u.isArchived == true);
        else 
            classes = allClasses;
        
        // console.log(classes);
    };

</script>

<svelte:head>
    <title>{titleProvider} Classrooms | Wavenet Nimbus</title>
</svelte:head>

<h1>
    {#if providerId == 1} Classrooms {:else} Teams {/if}
</h1>


<Modal bind:showModal={showDetails} showFooter={false} sizeClass={"modal-lg"} bind:isPageLoading={isFetchingStudents}>
    <div slot="header">
        <h4>
            {#if providerId == 1} Classroom {:else} Team {/if} Details
        </h4>
    </div>
    <div slot="content">       
        <div class="row"> 
            <div class="col-md-6">
                <h4>Teachers</h4>
                <hr/>                
                <div class="table">
                    {#if teachersInClass.length < 1}
                        <span>There are no teachers</span>
                    {:else}
                    {#each teachersInClass as teacher}
                    <div  style="padding: 0.5rem;border-bottom: 1px solid rgba(0, 0, 0, 0.1);"> {teacher}</div>                    
                    {/each}
                    <!-- <table class="table table-hover table-striped">
                        <tbody>
                            {#each teachersInClass as teacher}
                            <tr>
                                <td> {teacher} </td>
                            </tr>
                        {/each}
                        </tbody>
                    </table> -->
                    {/if}
                </div>              
            </div>           
                <div class="col-md-6">
                    <h4>Pupils</h4>
                    <hr/>
                    <div class="table">
                        {#if studentsInClass.length < 1}
                        <span>There are no pupils</span>
                    {:else}
                    {#each  studentsInClass as student}
                    <div  style="padding: 0.5rem;border-bottom: 1px solid rgba(0, 0, 0, 0.1);"> {student}</div>                    
                    {/each}                       
                        {/if}
                    </div>
                    <!-- <DataTable DataLength={studentsInClass.length} searching={false} paging={false}>
                        <thead>
                            <tr>
                                <th>Name </th>
                            </tr>
                        </thead>
                        <tbody>
                            {#each studentsInClass as student}
                                <tr>
                                    <td> {student} </td>
                                </tr>
                            {/each}
                        </tbody>
                    </DataTable> -->
                </div>
               
            </div>
            
        </div>        
    
</Modal>

<ModalConfirm
    bind:showModal={showConfirmationModal}
    zindex="1052"
    sizeClass="modal-md"  
    targetClass="confirm-options"
    showCancel={true}
    on:confirm={archiveClass(selectedCourseId /*, selectedCourseArchiveState*/)}
    on:close={() => showConfirmationModal == false }>
    <div slot="header">  
        <h4 class="title">
            Archive {providerId == 1 ? 'classroom' : 'team'}?
        </h4>
    </div>
    <div slot="content">
        Once archived, you will not be able to unarchive this {providerId == 1 ? 'classroom' : 'team'} 
        through Nimbus. All records for this {providerId == 1 ? 'classroom' : 'team'} 
        will be removed and it will no longer be managed by Nimbus.
    </div>
</ModalConfirm>

{#if isPageLoading}
    <Spinner />
{:else if classes == null}
<NoDataFound infoText="No Data Found">
    <p>Please ensure the configuration has been completed and data has been exported. Please click the 'Configuration' button below to view the settings.</p>
    <a class="btn btn-primary" href={resolveExportUrl(providerId,"/summary")}>Configuration</a>
</NoDataFound>

{:else}
<p>
    These are the exisiting {providerId == 1 ? "classrooms" : "teams"} in your {titleProvider}
    tenancy. {#if providerId == 3}In order to manage Teams, please <a href="https://admin.teams.microsoft.com/teams/manage" target="_blank">click here</a> to access the Teams Admin Console. {/if}
</p>
    <div>
        <Card cardTable={true}>
            <div slot="body">
                {#if providerId == 1 }
                <div class="form-group">
                    <div class="row">
                        <div class="col-lg-12" style="text-align: end;">                    
                            <label class="filter">
                                <input type="checkbox" id="filterClass" bind:checked={showArchived} on:click={handleChangeFilter} > 
                                Show archived only
                            </label>
                        </div>
                    </div>
                </div>
                {/if}

                <DataTable id ="allClasses" DataLength={classes.length}  paging={true} {columnDefs} message="There are currently no classes in your cloud tenancy.">
                   
                    <thead>
                        <tr>
                            <th>
                                {#if providerId == 1} Classroom {:else} Team {/if}
                            </th>
                            <th>Synced by Nimbus</th>
                            <!-- <th>Owner</th> -->
                            <th>Members</th>
                            <th>Created on</th>
                            <!-- {#if providerId == 1}<th>Last updated on</th>{/if} -->
                            {#if providerId == 1}
                            <!-- <th>State</th> -->
                            <th>State</th>
                            {/if}
                        </tr>
                    </thead>
                    <tbody>
                        {#each classes as cl}
                            <tr>
                                <td>{cl.name || ""}</td>

                                <td>{#if cl.isSyncedByNimbus} Yes {:else} No {/if} </td>                            

                                <td>
                                    <Button
                                        buttonClass={"btn-grey btn-sm"}
                                        buttonText="View"
                                        on:click={getStudentsInClass(
                                            cl.id,
                                            cl.students
                                        )} />
                                </td>

                                <td> {moment(cl.creationTime).format("DD/MM/YYYY")} </td>

                              

                                {#if providerId == 1}
                                    <!-- <td> {cl.courseState} </td> -->
                              
                                <td>
                                    <!-- <Switch
                                        bind:checked={cl.isArchived}
                                        on:switch={archiveClass(cl.id, cl.isArchived)}
                                        disabled={providerId == 1 && cl.courseState != "ACTIVE" && cl.courseState != "ARCHIVED"}
                                        checkedModalHeader="Archive {providerId == 1 ? 'classroom' : 'team'}?"
                                        uncheckedModalHeader="Activate {providerId == 1 ? 'classroom': 'team'}?"
                                        checkedModalMessage="Once archived, you will not be able to unarchive this {providerId == 1 ? 'classroom' : 'team'} 
                                        through Nimbus. All records for this {providerId == 1 ? 'classroom' : 'team'} 
                                        will be removed and it will no longer be managed by Nimbus."
                                        uncheckedModalMessage={providerId == 1
                                            ? "Activating the  classroom will make it visible to members who will then be able to makes changes."
                                            : "Unarchiving restores users' ability to send messages and edit the team, abiding by tenant and team settings."}
                                    /> -->
                                    
                                    {#if cl.isArchived == false}
                                        <Button
                                            buttonClass={"btn-secondary btn-sm"}
                                            buttonText="Archive"
                                            on:click={onClickArchive(cl.id)} />
                                    {:else}
                                    Archived
                                    {/if}
                                </td>
                                {/if}
                            </tr>
                        {/each}                      
                    </tbody>
                </DataTable>               
            </div>
        </Card>
    </div>
{/if}
